/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixLuxuryDatedSearchByLocationMap = require('./phoenixLuxuryDatedSearchByLocationMap.graphql');
export const phoenixLuxuryDatedSearchByLocationMapFilters = require('./phoenixLuxuryDatedSearchByLocationMapFilters.graphql');
export const phoenixLuxuryDatedSearchByGeoQueryMap = require('./phoenixLuxuryDatedSearchByGeoQueryMap.graphql');
export const phoenixLuxuryDatedSearchByGeoQueryMapFilters = require('./phoenixLuxuryDatedSearchByGeoQueryMapFilters.graphql');
